/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
import { getActiveLocale } from '@/ux-common/src/utils/locale';

export function formatDateForMeasure(
  dateRange: string | null | undefined | Date,
  locale?: string
) {
  if (!dateRange) return;

  const date = new Date(dateRange);
  // return empty string if date is invalid
  if (isNaN(date.getTime())) return '';
  const activeLocale = getActiveLocale(locale);
  const formatted = date.toLocaleString(activeLocale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return formatted;
}
